'use client'

import { Button, Icon, Typography } from '@shc/ui'
import { type SearchNamespace } from '@app/[locale]/(main)/search/_components/search-session'
import { saveAspotSummary } from '@lib/utilities/date-utilities'
import type { AppointmentDate } from '@lib/types'
import { type TypePlacePublic } from '@lib/location-types'
import { AnalyticsLink } from '@components/analytics'

interface LocationSaveASpotProps {
  placeId: TypePlacePublic['id']
  firstAvailableAppointment: AppointmentDate | string | null
  ctaLabel?: TypePlacePublic['scheduling_cta_label']
  schedulingUrl?: TypePlacePublic['scheduling_cta_url']
  description?: TypePlacePublic['scheduling_description']
}

const LocationSaveASpot = (props: LocationSaveASpotProps) => {
  const { placeId, firstAvailableAppointment, description, ctaLabel, schedulingUrl } = props
  let displayAvailability = ''

  // Analytics tracking vars
  const objectId = placeId?.toString() ?? '-1'
  const namespace: SearchNamespace = 'places'

  if (!firstAvailableAppointment) {
    // null corresponds to an empty array from the getNextAvailableAppointmentsForPlace()
    return <div>There are no available appointments. Walk-ins are welcome.</div>
  } else {
    if (typeof firstAvailableAppointment === 'object' && 'date' in firstAvailableAppointment) {
      displayAvailability = saveAspotSummary(firstAvailableAppointment.date)
    }

    return (
      <>
        {description && <div>{description}</div>}
        <div>
          {displayAvailability && (
            <Typography variant="body-semibold" className="pb-4">
              <Icon fixedWidth icon="calendar-days" className="text-gray-700" /> First available{' '}
              {displayAvailability.includes('today')
                ? displayAvailability.split('today')[1]
                : displayAvailability}
            </Typography>
          )}

          <AnalyticsLink
            as={Button}
            href={schedulingUrl ?? ''}
            algolia={{ conversion: { namespace, objectId } }}>
            {ctaLabel}
          </AnalyticsLink>
        </div>
      </>
    )
  }
}

export default LocationSaveASpot
